var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgReset = function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3a.5.5 0 0 1 .5.5v2.647a.5.5 0 0 1-.5.5H9.333a.5.5 0 0 1 0-1h1.62a3.797 3.797 0 0 0-3.871-.928A3.76 3.76 0 0 0 5.19 6.11a3.71 3.71 0 0 0 .094 4.435 3.77 3.77 0 0 0 1.95 1.312c.776.22 1.602.186 2.357-.095a3.76 3.76 0 0 0 1.837-1.464.5.5 0 0 1 .836.547A4.76 4.76 0 0 1 9.94 12.7a4.8 4.8 0 0 1-2.977.12 4.77 4.77 0 0 1-2.468-1.66 4.72 4.72 0 0 1-.12-5.629A4.76 4.76 0 0 1 6.772 3.77 4.8 4.8 0 0 1 11.5 4.785V3.5A.5.5 0 0 1 12 3",
    clipRule: "evenodd"
  })));
};
export { SvgReset as ReactComponent };
export default __webpack_public_path__ + "f3ce8b0bfea67614cbc5529936e6ffa2.svg";